module.exports = __webpack_public_path__ + "img/Emotional diagram-02.088a9e0d.png";